var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useCallback, useEffect, useRef, useState } from "react";
import lottie from "lottie-web";
export var LottiePlayer = function (_a) {
    var data = _a.data, onComplete = _a.onComplete, completeFrame = _a.completeFrame;
    var ref = useRef(null);
    var _b = __read(useState(), 2), animation = _b[0], setAnimation = _b[1];
    useEffect(function () {
        if (ref.current) {
            var anim_1 = lottie.loadAnimation({
                container: ref.current,
                animationData: data,
                renderer: "svg",
                autoplay: true,
                loop: false,
            });
            setAnimation(anim_1);
            return function () { return anim_1.destroy(); };
        }
        return function () { return undefined; };
    }, [data]);
    var completeTriggered = useRef({ value: false });
    var triggerOnComplete = useCallback(function () {
        if (onComplete == null)
            return;
        if (!completeTriggered.current.value) {
            completeTriggered.current.value = true;
            onComplete();
        }
    }, [onComplete]);
    useEffect(function () {
        if (completeFrame == null || animation == null) {
            return;
        }
        var cb = function () {
            if (animation.currentFrame > completeFrame) {
                triggerOnComplete();
            }
        };
        animation.addEventListener("enterFrame", cb);
        return function () {
            animation.removeEventListener("enterFrame", cb);
        };
    }, [triggerOnComplete, completeFrame, animation]);
    useEffect(function () {
        if (animation == null) {
            return;
        }
        animation.addEventListener("complete", triggerOnComplete);
        return animation.removeEventListener("complete", triggerOnComplete);
    }, [animation, triggerOnComplete]);
    return React.createElement("div", { ref: ref });
};
